module.exports = "/_next/static/images/lead-small-ed38a6894da38737201be293c13d7dd6.jpg";